import { AbstractControl, ValidationErrors } from "@angular/forms";

export function phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Don't validate empty values to allow optional fields
  }

  const phone = control.value.toString().trim();

  // Remove common formatting characters but keep the + for international format
  const cleanedPhone = phone.replace(/[\s\-()]/g, "");

  // Validation rules:
  // - Must start with '+'
  // - Followed by country code (digit 1-9)
  // - Then 6 to 14 additional digits (for a total of 7 to 15 digits, excluding '+')
  const internationalRegex = /^\+[1-9]\d{6,14}$/;

  if (!internationalRegex.test(cleanedPhone)) {
    return { phoneNumber: true };
  }

  return null;
}
